<template>
  <BModal
    id="modal-change-expedition-fee"
    hide-footer
    hide-header
    hide-header-close
    no-close-on-backdrop
    no-close-on-esc
    centered
    size="lg"
  >
    <div class="flex flex-col justify-center items-center text-center px-4 pt-4 pb-2">
      <img
        src="https://storage.googleapis.com/komerce/core/icon-popup-warning.png"
        alt="Komerce"
        width="100"
        class="mb-8"
      >
      <div class="flex flex-col gap-[4px]">
        <h4 class="font-semibold text-[24px] text-black">
          Konfirmasi Perubahan Biaya Ekspedisi?
        </h4>
        <span>Perubahan akan langsung berdampak ke transaksi partner</span>
      </div>
    </div>
    <div
      class="bg-[#FFF2E2] rounded-xl p-2 mb-2 text-[#333333] overflow-y-auto"
      style="max-height: 250px;"
    >
      <div
        v-for="(item, idx) in changeValues"
        :key="idx"
        class="my-1"
      >
        <div
          v-if="item.is_changed"
          class="mb-[4px]"
        >
          <strong>{{ item.service_name }}</strong>
        </div>
        <div class="ml-1">
          <li v-if="item.cashback_from_old !== item.cashback_from_new">
            Cashback ekspedisi dari <b>{{ item.cashback_from_old }}%</b> menjadi <b>{{ item.cashback_from_new }}%</b>
          </li>
          <li v-if="item.cod_fee_from_old !== item.cod_fee_from_new">
            Biaya COD ekspedisi dari <b>{{ item.cod_fee_from_old }}%</b> menjadi <b>{{ item.cod_fee_from_new }}%</b>
          </li>
          <li v-if="item.cashback_to_old !== item.cashback_to_new">
            Cashback Reguler dari <b>{{ item.cashback_to_old }}%</b> menjadi <b>{{ item.cashback_to_new }}%</b>
          </li>
          <li v-if="item.cashback_to_juragan_old !== item.cashback_to_juragan_new">
            Cashback Prioritas Juragan dari <b>{{ item.cashback_to_juragan_old }}%</b> menjadi <b>{{ item.cashback_to_juragan_new }}%</b>
          </li>
          <li v-if="item.cashback_to_saudagar_old !== item.cashback_to_saudagar_new">
            Cashback Prioritas Saudagar dari <b>{{ item.cashback_to_saudagar_old }}%</b> menjadi <b>{{ item.cashback_to_saudagar_new }}%</b>
          </li>
          <li v-if="item.cod_fee_to_old !== item.cod_fee_to_new">
            Biaya COD dari <b>{{ item.cod_fee_to_old }}%</b> menjadi <b>{{ item.cod_fee_to_new }}%</b>
          </li>
        </div>
      </div>
    </div>
    <div class="flex justify-center items-center gap-[4px] w-full">
      <BButton
        variant="outline-primary"
        class="flex-[45%]"
        @click="$bvModal.hide('modal-change-expedition-fee')"
      >
        Batal
      </BButton>

      <BButton
        variant="primary"
        class="flex-[45%]"
        @click="$emit('on-click-confirm-button', $event)"
      >
        Simpan
      </BButton>
    </div>
  </BModal>
</template>

<script>
export default {
  props: {
    changeValues: {
      type: Array,
      default: () => [],
      required: true,
    },
    shippingName: {
      type: String,
      default: '',
      required: false,
    },
  },
}
</script>
